import(/* webpackMode: "eager" */ "/vercel/path0/web/app/(main)/arbeider/[slug]/page.tsx");
